import {
  ASSET_CANVAS_LONG_SIDE_NODE_SIZE,
  ASSET_CANVAS_SQUARE_NODE_SIZE,
} from '@/lib/canvas/asset-canvas-node-size';
import { HISTORY_ARRANGE_CROSS_ZONE_GAP } from '@/lib/canvas/canvas-history-layout-constants';

export const START_X = 40;

export const START_Y = 40;

export type CanvasLayoutNodeSizeByKey = Readonly<Record<string, { width: number; height: number }>>;

export const NODE_WIDTH = ASSET_CANVAS_SQUARE_NODE_SIZE;

export const NODE_HEIGHT = 560;

export const NODE_GAP = 72;

/** 抽帧/裁剪辅助落位：相对源节点右侧的水平间距（大于 NODE_GAP，避免贴住/盖住根节点）。 */
export const STORYBOARD_ASSIST_RIGHT_OF_SOURCE_GAP = 200;

export const MEDIA_NODE_Z_INDEX_OFFSET = 1;

export const PLAN_NODE_Z_INDEX_OFFSET = 100;

export const HISTORY_NODE_Z_INDEX_OFFSET = 200;

export const UNKNOWN_STORYBOARD_ITEM_TYPE_ORDER = 99;

export const STORYBOARD_RESOURCE_TO_ITEM_GAP = 160;

export const DEFAULT_STORYBOARD_ITEM_X = START_X + NODE_WIDTH + STORYBOARD_RESOURCE_TO_ITEM_GAP;

export const STORYBOARD_MAIN_TO_PLAN_INFO_GAP = 300;

/** 分区骨架：音频列与 D/E/F 各区间的水平间距。 */
export const ARRANGED_ZONE_GAP = 160;

export const ARRANGED_INHERENT_PAIR_GAP = 80;

// 信息与音频组节点宽度，用于整理画布的布局估算。
export const STORYBOARD_ITEM_INFO_NODE_WIDTH = 420;

export const STORYBOARD_AUDIO_COLLECTION_NODE_WIDTH = 460;

export const STORYBOARD_AUDIO_COLLECTION_NODE_FALLBACK_HEIGHT = NODE_HEIGHT;

/**
 * D4-swap-de-columns 列语义（纠偏）：
 * A/B/C 音频 → **D=参考图/资产关联** → **E=会话历史 hub（图/视频/资产）** → **F+=方案根**；
 * history_group 仍在方案根右侧（再右一列）。
 */
/** A 列：对白/音效会话 hub 默认宽（仅当 reserveAudioConversationHubColumn）。 */
export const DEFAULT_STORYBOARD_AUDIO_HUB_COLUMN_WIDTH = ASSET_CANVAS_LONG_SIDE_NODE_SIZE;

export const DEFAULT_STORYBOARD_AUDIO_COLUMN_B_WIDTH = STORYBOARD_AUDIO_COLLECTION_NODE_WIDTH;

export const DEFAULT_STORYBOARD_AUDIO_COLLECTION_X = START_X;

export const DEFAULT_STORYBOARD_VOICEOVER_X =
  DEFAULT_STORYBOARD_AUDIO_COLLECTION_X +
  DEFAULT_STORYBOARD_AUDIO_COLUMN_B_WIDTH +
  ARRANGED_INHERENT_PAIR_GAP;

/** E 列：图/视频/资产会话 hub 默认宽（与 conversation 16:9 长边一致）。 */
export const DEFAULT_SESSION_HISTORY_COLUMN_WIDTH = ASSET_CANVAS_LONG_SIDE_NODE_SIZE;

export const DEFAULT_STORYBOARD_RESOURCE_X =
  DEFAULT_STORYBOARD_VOICEOVER_X + STORYBOARD_AUDIO_COLLECTION_NODE_WIDTH + ARRANGED_ZONE_GAP;

export const DEFAULT_STORYBOARD_INFO_X = DEFAULT_STORYBOARD_ITEM_X;

export const DEFAULT_STORYBOARD_PLAN_INFO_X =
  DEFAULT_STORYBOARD_INFO_X + STORYBOARD_ITEM_INFO_NODE_WIDTH + STORYBOARD_MAIN_TO_PLAN_INFO_GAP;

export const DEFAULT_STORYBOARD_PLAN_X =
  DEFAULT_STORYBOARD_RESOURCE_X + ASSET_CANVAS_LONG_SIDE_NODE_SIZE + ARRANGED_ZONE_GAP;

export const STORYBOARD_LEFT_COLUMN_TO_INFO_GAP = 140;

export const ARRANGED_ROW_HEIGHT = NODE_HEIGHT + NODE_GAP;

export const ARRANGED_SNAPSHOT_NODE_Z_INDEX = 320;

/** 图片方案区与视频区垂直跨区间距。
 * 与整理投影避让的 HISTORY_ARRANGE_CROSS_ZONE_GAP 对齐，确保展开历史后仍有明确区间空隙。
 */
export const ARRANGED_PLAN_ZONE_GAP = HISTORY_ARRANGE_CROSS_ZONE_GAP;

/** 区内节点垂直步进（导出供测试锁定跨区 > 区内）。 */
export const ARRANGED_WITHIN_ZONE_GAP = NODE_GAP;
